/* global angular, $ */
angular.module('ua5App')
    .directive('resourceProspectiveform', ['$state', '$timeout', '$rootScope', '$sce', 'FormsFactory', function($state, $timeout, $rootScope, $sce, FormsFactory) {
        return {
            restrict: 'A',
            templateUrl: 'components/resource-prospectiveform/resource-prospectiveform.html',
            scope: {
                sectionIndex: '@'
            },
            link: function($scope, element, attrs) {

                var contactFields = [
                    'name_first',
                    'name_last',
                    'gender',

                    'address_street',
                    'address_city',
                    'address_state',
                    'address_code',
                    'address_country',

                    'intl_address',
                    'intl_student',

                    'education',
                    'email',
                    'email2',

                    'level',
                    'year',
                    'major',
                    'concentration',
                    'major_alternate'
                ];

                $scope.majors = [
                    {
                        name: 'Architecture & Urban Design',
                        dropdowns: [
                            {
                                name: 'concentration',
                                values: [
                                    'Architecture and Urban Design'
                                ]
                            }
                        ]
                    },
                    {
                        name: 'Art',
                        dropdowns: [
                            {
                                name: 'concentration',
                                values: [
                                    'Ceramics',
                                    'New Genres',
                                    'Painting & Drawing',
                                    'Photography',
                                    'Sculpture'
                                ]
                            }
                        ]
                    },
                    {
                        name: 'Design Media Arts',
                        dropdowns: [
                            {
                                name: 'concentration',
                                values: [
                                    'Design Media Arts'
                                ]
                            }
                        ]
                    },
                    {
                        name: 'Ethnomusicology',
                        dropdowns: [
                            {
                                name: 'concentration',
                                values: [
                                    'Ethnomusicology',
                                    'Jazz Studies',
                                    'Systematic Music'
                                ]
                            }
                        ]
                    },
                    {
                        name: 'Music',
                        dropdowns: [
                            {
                                name: 'concentration',
                                values: [
                                    'Composition',
                                    'Education',
                                    'Performance'
                                ]
                            },
                            {
                                name: 'instrument',
                                values: [
                                    'Bassoon',
                                    'Cello',
                                    'Clarinet',
                                    'Conducting',
                                    'Euphonium',
                                    'Flute',
                                    'Forte Piano',
                                    'French Horn',
                                    'Guitar',
                                    'Harp',
                                    'Harpsichord',
                                    'Oboe',
                                    'Orchestra Band',
                                    'Organ',
                                    'Percussion',
                                    'Piano',
                                    'Saxophone',
                                    'String Bass',
                                    'Trombone',
                                    'Trumpet',
                                    'Tuba',
                                    'Viola',
                                    'Violin',
                                    'Voice'
                                ]
                            }
                        ]
                    },
                    {
                        name: 'World Arts and Cultures/Dance ',
                        dropdowns: [
                            {
                                name: 'concentration',
                                values: [
                                    'Cultural Studies',
                                    'Dance'
                                ]
                            }
                        ]
                    }
                ];

                $scope.inputFocus = {};

                for (var i = 0; i< contactFields.length; i++) {
                    $scope.inputFocus[contactFields[i]] = false;
                }

                $('.resource-prospectiveform').find('label').each(function() {
                    if (!$(this).hasClass('resources-connectform__label-long')) {

                        var w = $(this).width(),
                            paddingW = w + 20 + 'px';

                        if ($(this).hasClass('resources-connectform__label-dropdown')) {
                            $(this).next().css('margin-left', paddingW);
                            $(this).next().css('width', 'calc( 100% - ' + paddingW + ')');
                        } else if ($(this).hasClass('resources-connectform__label-radio')) {
                            $(this).next().css('margin-left', paddingW);
                        } else {
                            $(this).next().css('text-indent', paddingW);
                        }
                    }
                });

                $('label', element).click(function() {
                    var labelID = $(this).attr('for');
                    $('#' + labelID).trigger('click');
                });

                $scope.concentrationArray = [];
                $scope.changeConcentration = function(i, value) {
                    $scope.concentrationArray[i] = value;
                    $scope.contact.concentration = $scope.concentrationArray.join(',');
                };

                $scope.changeMajor = function() {
                    $scope.concentrationArray = [];
                };

                $scope.submitContact = function() {

                    var cForm = $scope.contactForm;

                    if ($scope.contactForm.$invalid) {
                        alert('Please fill in the required fields above in the proper format.');
                    } else if ($scope.contact.email !== $scope.contact.email2) {
                        alert('Please confirm your email address.');
                    } else {
                        var fieldsObj = {};
                        for (var i = 0; i<contactFields.length; i++) {
                            var val = cForm[contactFields[i]].$modelValue ? cForm[contactFields[i]].$modelValue  : null;
                            if (val && typeof val === 'object') {
                                val = val.value ? val.value : val.name;
                            }
                            fieldsObj[contactFields[i]] = val;
                        }

                        FormsFactory.prospective(fieldsObj).then(function(response) {
                            if (response.data && response.data.Errors) {
                                // error handling
                                alert(response.data.Errors.join('\n'));
                            } else if (response.data) {
                                // success;
                                alert('Thank you for requesting information!');
                                $('.hasForm .openFormLink', element).click();
                            } else {
                                // unknown error
                                alert('An error occured, please try submitting your form again.');
                            }
                        });
                    }
                };

                $timeout(function() {
                    $rootScope.$broadcast('resourceComponentPosition', {sectionIndex: $scope.sectionIndex});
                });
            }
        };
    }])
;
